import { render, staticRenderFns } from "./IconSortIncrease.vue?vue&type=template&id=c49c2bca&"
import script from "./IconSortIncrease.vue?vue&type=script&lang=js&"
export * from "./IconSortIncrease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports